import { Box, Button, Flex, FormControl, FormErrorMessage, FormLabel, HStack, Image, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, useDisclosure } from "@chakra-ui/react";
import React, { useEffect, useState } from 'react';
// import { FaCaretDown, FaRegCalendarCheck, FaArrowRight, FaPhone, FaChalkboardTeacher, FaPhoneAlt } from 'react-icons/fa';
import { useNavigate, useParams } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import LogisticsAndAccomodation from "../../../components/trainee/survey/LogisticsAndAccomodation";
import Others from "../../../components/trainee/survey/Others";
import SurveyLine from "../../../components/trainee/survey/SurveyLine";
import TrainersEvaluation from "../../../components/trainee/survey/TrainersEvaluation";
import TrainingProgrammeEvaluation from "../../../components/trainee/survey/TrainingProgrammeEvaluation";
import rarrow from '../../../img/rarrow.svg';
import { ICenter } from "../../../models/centers.model";
import { ITrainerBio } from "../../../models/trainerbio.model";
import AdminHelpers from "../../../services/admin/admin.service";
import SurveyService from "../../../services/admin/survey.service";
import userService from "../../../services/user.service";


const Survey = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    const initialRef = React.useRef(null)
    const finalRef = React.useRef(null)
    const { isOpen, onOpen, onClose } = useDisclosure()

    const params = useParams();
    const survey_uuid: string | any = params.survey_uuid;

    const [pageState, setPagestate] = useState(0)

    // const [courseTitle, setCourseTitle] = useState<string>();
    const [courseQuestions, setCourseQuestions] = useState([]);
    const [trainerQuestions, setTrainerQuestions] = useState([]);
    const [centreQuestions, setCentreQuestions] = useState([]);
    const [othersQuestions, setOthersQuestions] = useState([]);

    const [courseTemplateCode, setCourseTemplateCode] = useState('');
    const [centreTemplateCode, setCentreTemplateCode] = useState('');
    const [trainerTemplateCode, setTrainerTemplateCode] = useState('');
    const [othersTemplateCode, setOthersTemplateCode] = useState('');
    const [centers, setCenters] = useState<ICenter | any>([]);
    const [trainers, setTrainers] = useState<ITrainerBio | any>([]);
    const [trainerId, setTrainerId] = useState('');
    const [centerId, setCenterId] = useState('');
    const [emailAddress, setEmailAdress] = useState('');

    const [userId, setUserId] = useState<number>(0);
    const [singleSurvey, setSingleSurvey] = useState({});

    const pages = [
        { index: 1, component: TrainingProgrammeEvaluation },
        { index: 2, component: TrainersEvaluation },
        { index: 3, component: LogisticsAndAccomodation },
        { index: 4, component: Others }
    ]

    const switchPage = () => {

        const Component = pages[pageState].component;
        return <Component
            nextPage={nextPage}
            prePage={prePage}
            courseQuestions={courseQuestions}
            trainerQuestions={trainerQuestions}
            centreQuestions={centreQuestions}
            othersQuestions={othersQuestions}
            courseTemplateCode={courseTemplateCode}
            centreTemplateCode={centreTemplateCode}
            trainerTemplateCode={trainerTemplateCode}
            othersTemplateCode={othersTemplateCode}
            userId={userId}
            emailAdress={emailAddress}
            trainerId={trainerId}
            centerId={centerId} />

    }
    const nextPage: any = () => {
        if (pageState < pages.length) {
            let pstate = pageState

            setPagestate(++pstate)
        }
        localStorage.setItem("page_no", pageState.toString());
    }

    const prePage = () => {
        if (pageState > 0) {
            let pstate = pageState
            setPagestate(--pstate)
        }
        localStorage.setItem("page_no", pageState.toString());
    }

    useEffect(() => {
        onOpen();
        const pageNo = localStorage.getItem("page_no") ? localStorage.getItem("page_no") : '0';
        if (pageNo)
            setPagestate(parseInt(pageNo));
        SurveyService.getSingleSurvey(survey_uuid).then(
            (res) => {
                
                setSingleSurvey(res.data);
                setCourseQuestions(res.data.course_questions);
                setTrainerQuestions(res.data.trainer_questions);
                setCentreQuestions(res.data.centre_questions);
                setOthersQuestions(res.data.other_questions);
                setCourseTemplateCode(res.data.course_survey_template_code);
                setCentreTemplateCode(res.data.centre_survey_template_code);
                setTrainerTemplateCode(res.data.trainer_survey_template_code);
                setOthersTemplateCode(res.data.other_survey_template_code);

            }).catch(err => console.error(err));
        userService.getUserBio().then(
            (res) => {
                
                setUserId(res.data.id)
            }
        ).catch(err => console.error(err));
        AdminHelpers.getAllCenters().then(
            (res) => {
                setCenters(res.data);
            }
        )
        AdminHelpers.getTrainers().then(
            (res) => {
                setTrainers(res.data);

            }
        )

    }, [survey_uuid, onOpen]);

    return (
        <>
            <DashboardHeader />
            <Flex justifyContent="center" bg='#F9F8F8' height='100%' bgSize='cover'>
                <Box mt='50px' bg='#F9F8F8' height='100%' >
                    <Box height="3rem" width='960px' bg='white' boxShadow="0px 0px 4px rgba(0, 0, 0, 0.08)" px={8} py={2} >
                        <HStack justifyContent="space-evenly" >
                            <SurveyLine position="1" title="Training Programme Evaluation" bgColor={pageState === 0 ? "brand.2" : "brand.1"} textColor={pageState === 0 ? "#EC3337" : "brand.subtitle"} fontWeight={pageState === 0 ? "700" : "400"} />
                            <Image src={rarrow} />

                            <SurveyLine position="2" title="Trainers Evaluation" bgColor={pageState === 1 ? "brand.2" : "brand.1"} textColor={pageState === 1 ? "#EC3337" : "brand.subtitle"} fontWeight={pageState === 1 ? "700" : "400"} />
                            <Image src={rarrow} />

                            <SurveyLine position="3" title="Logistics & Accomodation" bgColor={pageState === 2 ? "brand.2" : "brand.1"} textColor={pageState === 2 ? "#EC3337" : "brand.subtitle"} fontWeight={pageState === 2 ? "700" : "400"} />
                            <Image src={rarrow} />

                            <SurveyLine position="4" title="Others" bgColor={pageState === 3 ? "brand.2" : "brand.1"} textColor={pageState === 3 ? "#EC3337" : "brand.subtitle"} fontWeight={pageState === 3 ? "700" : "400"} />
                        </HStack>

                    </Box>
                    <Box boxShadow="base" width='960px' bg="white" height="auto" mb='50px' mt={6} py={10} px={8} >
                        <Modal
                            initialFocusRef={initialRef}
                            finalFocusRef={finalRef}
                            isOpen={isOpen}
                            onClose={onClose}
                        >
                            <ModalOverlay />
                            <ModalContent>
                                <ModalHeader>Please fill in the following</ModalHeader>
                                <ModalCloseButton />
                                <ModalBody pb={6}>
                                    <FormControl mt={4}>
                                        <FormLabel>Email address:</FormLabel>
                                        <Input placeholder="e.g trainee@example.com" value={emailAddress} onChange={(event) => setEmailAdress(event.target.value)} required={true} />
                                        <FormErrorMessage>Email is required.</FormErrorMessage>
                                    </FormControl>
                                    <FormControl mt={4}>
                                        <FormLabel>Who was your trainer ?</FormLabel>
                                        <Select placeholder='please select an option' fontSize="14px" value={trainerId} onChange={(event) => setTrainerId(event.target.value)} isRequired>
                                            {
                                                trainers.map((each: any, index: number) =>
                                                    <option key={index} value={each.id}>{each.name}...</option>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl mt={4}>
                                        <FormLabel>Where was your training center?</FormLabel>
                                        <Select placeholder='please select an option' fontSize="14px" value={centerId} onChange={(event) => setCenterId(event.target.value)} isRequired>
                                            {
                                                centers.map((each: any, index: number) =>
                                                    <option key={index} value={each.id}>{each.name.slice(0, 32)}...</option>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                </ModalBody>

                                <ModalFooter>
                                    <Button colorScheme="red"
                                        borderRadius="4px"
                                        fontSize="13px"
                                        fontWeight="600"
                                        onClick={() => onClose()}
                                    >Submit
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </Modal>

                        {
                            switchPage()
                        }

                    </Box>
                </Box>
            </Flex>
        </>
    );
}

export default Survey;